import React, { useEffect, useRef, useState, useContext } from "react";
import { Steps } from "../../utils/FormData";
import { Formik, Form, Field, ErrorMessage } from "formik";
import upload_Icon from "../../assets/upload_icon.svg";
// import SuccessModal from "../Modal/SuccessModal";
import mailIcon from "../../assets/mailIcon.svg";
import pinIcon from "../../assets/pin.svg";
import phonIcon from "../../assets/phone.svg";
import startCrossIcon from "../../assets/Closebutton.svg";
import featuredIcon from "../../assets/Featured icon2.svg";
import secured from "../../assets/image 129.png";
import endCrossIcon from "../../assets/Close.svg";
import * as Yup from "yup";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";

import states from "./states.json";
import busisnesstypes from "./busisnesstypes.json";
import "../GrowNowComp/loader.css";

import { Context } from "../..";
import {
  formatNumber,
  removePixels,
  shootGoogleTag,
  shotPixels,
  tagmanager,
} from "../../utils/helpers";
import HoldModal from "./HoldModal";

import PhoneInput from "react-phone-input-2";
import { isPossiblePhoneNumber, isValidPhoneNumber } from "libphonenumber-js";

const apiUrl =
  /*"http://127.0.0.1:3331" ||*/ "https://hubspot-proxy-0d8d4ed31dcb.herokuapp.com";

const FILE_SIZE = 5 * 1024 * 1024; // 2MB
const SUPPORTED_FORMATS = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "text/plain",
  "text/csv",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/pdf",
  "text/html",
  "image/webp",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];
// Step 3 Validation Schema
const step3ValidationSchema = Yup.object({});

const StepForm = () => {
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [getRespErr, setGetRespErr] = useState("");
  const [showHoldModal, setShowHoldModal] = useState(false);
  const [existId, setExistId] = useState("");
  const [country, setCountry] = useState("");
  const formRef = useRef();
  const navigate = useNavigate();
  //const [isSubmitting, setIsSubmitting] = useState(false);
  const inputRefs = [];

  const location = useLocation();
  const contactId = location.state?.contactId;
  const initFormData = location.state?.formData;
  const initEmail = initFormData?.email;
  const initBusinessName = initFormData?.business_name;
  const initPhone = initFormData?.phone;
  const initName = initFormData?.full_name;
  //console.log(initFormData, 'initFormData');

  const {
    value: { localizationModule },
  } = useContext(Context);

  const validatePhone = (phone) => {
    if (!phone) return false;
    return (
      isPossiblePhoneNumber(phone, country ?? "US") &&
      isValidPhoneNumber(phone, country ?? "US")
    );
  };

  const step1ValidationSchema = Yup.object({
    full_name: Yup.string()
      .min(2, localizationModule.getText("validation.full_name.min"))
      .max(50, localizationModule.getText("validation.full_name.max"))
      .required(localizationModule.getText("validation.full_name.required")),

    business_name: Yup.string()
      .min(2, localizationModule.getText("validation.business_name.min"))
      .max(100, localizationModule.getText("validation.business_name.max"))
      .required(
        localizationModule.getText("validation.business_name.required")
      ),

    email: Yup.string()
      .email(localizationModule.getText("validation.email.invalid"))
      .required(localizationModule.getText("validation.email.required")),

    phone: Yup.string().test(
      "validity",
      localizationModule.getText("phonenotvalid"),
      validatePhone
    ),
  });

  const step2ValidationSchema = Yup.object({
    business_type: Yup.string().required(
      localizationModule.getText("validation.business_type.required")
    ),

    business_date: Yup.date()
      .required(localizationModule.getText("validation.business_date.required"))
      .test(
        "min-6-months",
        localizationModule.getText("validation.business_date.min_6_months"),
        (value) => {
          const sixMonthsAgo = new Date();
          sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
          return value <= sixMonthsAgo;
        }
      ),

    // business_address: Yup.string()
    //   .min(5, localizationModule.getText("validation.business_address.min"))
    //   .max(200, localizationModule.getText("validation.business_address.max"))
    //   .required(
    //     localizationModule.getText("validation.business_address.required")
    //   ),

    business_state: Yup.string().required(
      localizationModule.getText("validation.business_state.required")
    ),
    monthly_revenue: Yup.string().required(
      localizationModule.getText("validation.monthly_revenue.required")
    ),

    avg_monthly_credit: Yup.number()
      .typeError(
        localizationModule.getText("validation.avg_monthly_credit.number")
      )
      .required(
        localizationModule.getText("validation.avg_monthly_credit.required")
      ),

    current_funding: Yup.string().required(
      localizationModule.getText("validation.current_funding.required")
    ),

    // consent_credit_check: Yup.boolean().oneOf(
    //   [true, false],
    //   localizationModule.getText("validation.consent_credit_check.required")
    // ),

    // terms_conditions: Yup.boolean().oneOf(
    //   [true, false],
    //   localizationModule.getText("validation.terms_conditions.required")
    // ),
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    if (typeof contactId !== "undefined") {
      setExistId(contactId);
      setCurrentStep(2);
    }

    // return () => {

    // };
  }, []);

  useEffect(() => {
    if (currentStep === 2) {
      tagmanager("headerGtag", "AW-11530121883");
      tagmanager("headerGtag2", "G-470989317");
      tagmanager("headerGtag3", "G-00LTPXRR8L");

      return () => {
        document.getElementById("headerGtag")?.remove();
        document.getElementById("headerGtagConfig")?.remove();
        document.getElementById("headerGtag2")?.remove();
        document.getElementById("headerGtag2Config")?.remove();
        document.getElementById("headerGtag3")?.remove();
        document.getElementById("headerGtag3Config")?.remove();
      };
    }
  }, [currentStep]);

  useEffect(() => {
    if (getRespErr) {
      const timer = setTimeout(() => {
        setGetRespErr("");
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [getRespErr]);

  // const closeModal = () => {
  //   setIsModalOpen(false);
  //   navigate("/");
  // };

  const handleImage = (index) => {
    //console.log(inputRef, "test out");
    if (inputRefs[index]) {
      inputRefs[index].click();
    }
  };

  const handleNext = async (
    validateForm,
    setTouched,
    values,
    setSubmitting
  ) => {
    // e.preventDefault();
    // Perform validation for the current step
    const errors = await validateForm(values);

    // Log individual field errors for debugging
    Object.keys(errors).forEach((field) => {
      console.log(`Error in ${field}: ${errors[field]}`);
    });

    // If there are errors, mark the fields as touched
    if (Object.keys(errors).length > 0) {
      setTouched({
        ...Object.keys(values).reduce((acc, key) => {
          acc[key] = true;
          return acc;
        }, {}),
      });
      return; // prevent moving to the next step
    }
    let existingId;
    const params = new URLSearchParams(window.location.search);
    if (currentStep === 1) {
      let obj = {
        full_name: values?.full_name,
        email: values?.email,
        phone: values?.phone,
        business_name: values?.business_name,
        business_address: values?.business_address,
        href: window.location.href,
        lead_source: params.get("fbclid")
          ? "Facebook"
          : params.get("gclid")
          ? "Google"
          : "Organic",
        step: 1,
      };

      try {
        console.log(obj, "obj 1 is hereww");
        // Sending data to the API
        setSubmitting(true);
        const response = await axios.post(
          `${apiUrl}/leadPush?pid=procash`,
          obj,
          {
            headers: {
              "Content-Type": "text/plain;charset=utf-8",
            },
          }
        );

        // Handle response data
        if (response.data?.result?.id) {
          console.log("Business created successfully:", response.data.result);

          setExistId(response.data.result.id);
        } else {
          // console.error("Error:", response.data.message);
          console.log(response.data, "response");
          // Handle validation error response from API
          alert(response.data?.result.message);
          //setGetRespErr(response.data.result.message); // Show error message
        }
      } catch (error) {
        alert(error.message);
      } finally {
        setSubmitting(false);
      }
    }

    if (currentStep === 2) {
      let obj = {
        business_type: values?.business_type,
        business_date: values?.business_date,
        business_address: values?.business_address,
        business_state: values?.business_state,
        monthly_revenue: values?.monthly_revenue,
        average_monthly_credit_debit: values?.avg_monthly_credit,
        // avg_monthly_card:values?.avg_monthly_card,
        current_funding: values?.current_funding?.replaceAll(",", ""),
        // consent_credit_check: values?.consent_credit_check,
        // terms_conditions: values?.terms_conditions,
        full_name: values?.full_name,
        email: values?.email,
        phone: values?.phone,
        business_name: values?.business_name,
        step: 2,
      };

      try {
        console.log(existId, "obj 1 is herewwexistId");
        // Sending data to the API
        if (existId) {
          console.log(obj, "obj 1 is hereww");
          // Sending data to the API
          setSubmitting(true);
          const response = await axios.post(
            `${apiUrl}/leadUpdate?id=${existId}&pid=procash`,
            obj,
            {
              headers: {
                "Content-Type": "text/plain;charset=utf-8",
              },
            }
          );

          //TODO handle update

          if (response.data.result.id) {
            shootGoogleTag();
            shotPixels();
            setShowHoldModal(true);
            console.log(
              "Business updated successfully:",
              response.data.result.properties
            );
            setSubmitting(false);
          } else {
            // console.error("Error:", response.data.message);
            console.log(response, "response");

            // Handle validation error response from API
            setGetRespErr(response.data.result.message); // Show error message
          }
        }
      } catch (error) {
        // console.error("Error:", error?.response?.data?.message);
        // Handle unexpected errors (e.g., server issues)

        if (error?.response?.data?.message?.code) {
          return setGetRespErr(error?.response?.data?.code);
        }
        setGetRespErr(error?.response?.data?.message);
      } finally {
        setSubmitting(false);
      }
    }

    // If validation passes, move to the next step
    setCurrentStep((prevStep) => prevStep + 1);
    formRef.current?.scrollIntoView({
      behavior: "smooth",
    });
  };

  const handleStepSubmit = async (
    values,
    { setSubmitting, validateForm, setTouched, resetForm }
  ) => {
    // Handle form submission for the current step
    // event.preventDefault();

    if (currentStep === 1) {
      //console.log("yues")
      handleNext(validateForm, setTouched, values, setSubmitting);
    } else if (currentStep === 2) {
      handleNext(validateForm, setTouched, values, setSubmitting);
      console.log("Form Submitted:", values);
      // Add your final submit logic here
      setSubmitting(false);
    } else if (currentStep === 3) {
      if (!values.statment.length) {
        return void alert("Please upload a file");
      }
      const type = values.statment?.[0].type;
      const name = values.statment?.[0].name;

      const query =
        "?" +
        new URLSearchParams({
          stream: true,
          type,
          pid: "procash",
          hubspotId: existId,
          name: `${existId || new Date().getTime()}-${name}`,
        });

      const success = await axios(`${apiUrl}/uploadFile${query}`, {
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*/*",
        },
        data: values.statment,
      })
        .catch((e) => {
          alert(e.response?.data || e.message);
        })
        .finally(() => {
          setSubmitting(false);
        });

      if (success) {
        removePixels();
        navigate("/thank-you", {
          state: { fromRegistration: "registration-form", existId },
        });
      }
    }
  };

  return (
    <>
      {/* step form */}
      <div className="py-[43px]">
        <p className="font-normal text-sm text-[#667085]">
          {localizationModule.getText("home")} /{" "}
          <span className="font-normal text-[#66708573]">
            {localizationModule.getText("appform")}
          </span>
        </p>
        <h2 className="font-semibold text-3xl text-[#101828] mt-3 mb-8">
          {localizationModule.getText("welcometo")} ProCash.ai!
        </h2>
        {getRespErr && (
          <div className="border border-[#F4B0A1] rounded-xl bg-[#FFF5F3] flex justify-between items-center py-3 px-5 mb-6">
            <div className="flex items-center gap-4">
              <div
                className="w-6 h-6 flex justify-center items-center rounded-md"
                style={{
                  background:
                    "linear-gradient(180deg, #E88B76 0%, #CA5048 100%)",
                }}
              >
                <img src={endCrossIcon} alt="" />
              </div>
              <p className="text-[13px] text-[#101828] font-medium">
                {getRespErr}
              </p>
            </div>
            <div onClick={() => setGetRespErr("")} className="cursor-pointer">
              <img src={startCrossIcon} alt="" />
            </div>
          </div>
        )}
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12  sm:gap-[30px] md:gap-[30px] lg:gap-[30px] xl:gap-[30px]">
          <div className="bg-white col-span-12 sm:col-span-12 md:col-span-5 lg:col-span-5 xl:col-span-5 rounded-t-2xl border-b  sm:rounded-2xl md:rounded-2xl lg:rounded-2xl xl:rounded-2xl border border-[#EFEFEF] p-6 h-full flex flex-col justify-between">
            <div>
              {Steps(localizationModule).map((step, index) => (
                <div
                  key={index}
                  className={`flex gap-4 mb-0 sm:mb-6 md:mb-6 lg:mb-6 xl:mb-6 items-center ${
                    currentStep === step.count ? "" : "hidden"
                  } sm:flex md:flex lg:flex xl:flex`}
                >
                  <h4
                    className={`text-[14px] sm:text-xl md:text-xl lg:text-xl xl:text-xl font-bold rounded-full min-w-[40px] sm:w-[48px] md:w-[48px] lg:w-[48px]  xl:w-[48px] min-h-[40px]  sm:h-[48px] md:h-[48px] lg:h-[48px] xl:h-[48px]  flex items-center justify-center ${
                      currentStep === step.count
                        ? "border border-[#201564] bg-[#6853E4]   text-white "
                        : "border border-[#98A2B3] bg-white text-[#98A2B3]"
                    } border-[#201564]`}
                    style={{
                      boxShadow:
                        currentStep === step.count
                          ? "-1px 1px 4px 0px #FFFFFF73 inset, 1px 1px 4px 0px #FFFFFF73  inset, 0px -2px 1px 0px #00000040 inset"
                          : "",
                    }}
                  >
                    {step.count}
                  </h4>
                  <div>
                    <h6
                      className={`text-base  text-[#101928] ${
                        currentStep === step.count
                          ? "font-semibold"
                          : "font-normal"
                      }`}
                    >
                      {step.title}
                    </h6>
                  </div>
                </div>
              ))}
            </div>
            <div className="hidden sm:hidden md:block lg:block xl:block">
              <h4 className="text-[#171717] font-semibold text-base">
                {localizationModule.getText("needhelp")}
              </h4>
              <p className="font-normal text-base text-[#303030A3] mt-[10px]">
                {localizationModule.getText("gettoknowreach")}
              </p>
              <button
                className="border rounded-full border-[#30303033] shadow-[0px -0.5px 0px 0px #16191D1F inset] px-3 py-[10px] font-medium text-sm text-[#171717] hover:bg-[#5D74F1] hover:text-[#fff] mt-[30px]"
                onClick={() =>
                  window.open("mailto:support@procash.ai", "_self")
                }
              >
                {localizationModule.getText("contactus")}
              </button>
            </div>
          </div>
          <div className="banner-wrapper col-span-12 sm:col-span-12 md:col-span-7 lg:col-span-7 xl:col-span-7 h-full md:max-h-[646px] lg:max-h-[646px] xl:max-h-[646px]">
            {currentStep === 3 && (
              <div className=" bg-white rounded-b-2xl sm:rounded-2xl md:rounded-2xl lg:rounded-2xl xl:rounded-2xl border border-[#fff] p-6 financial-banner">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img src={featuredIcon} alt="featuredIcon" />
                  <h2>{localizationModule.getText("greatNews")}</h2>
                </div>
                <p>{localizationModule.getText("foundLander")}</p>
              </div>
            )}
            <div className=" bg-white rounded-b-2xl sm:rounded-2xl md:rounded-2xl lg:rounded-2xl xl:rounded-2xl border border-[#fff] p-6  overflow-y-auto overflow-x-hidden ">
              <div ref={formRef}>
                <h1 className="font-semibold text-base sm:text-2xl md:text-2xl lg:text-2xl xl:text-2xl text-[#101828] mb-4">
                  {Steps(localizationModule)[currentStep - 1]?.title}
                </h1>
                <Formik
                  initialValues={{
                    full_name: initName || "",
                    business_name: initBusinessName || "",
                    business_address: "",
                    business_state: "",
                    email: initEmail || "",
                    phone: initPhone || "",
                    business_type: "",
                    business_date: "",
                    monthly_revenue: "",
                    avg_monthly_credit: "",
                    current_funding: "",
                    // consent_credit_check: false,
                    // terms_conditions: false,
                    avg_monthly_sales_1: "",
                    avg_monthly_sales_2: "",
                    other_monthly_sources: "",
                    existing_loans: "no",
                    existing_financing_amount: "",
                    monthly_payment: "",
                    bank_acc_inf: "",
                    average_monthly_card: "",
                    statment: [],
                  }}
                  validationSchema={
                    currentStep === 1
                      ? step1ValidationSchema
                      : currentStep === 2
                      ? step2ValidationSchema
                      : step3ValidationSchema
                    // : currentStep === 3
                    // ? s
                    // : step4ValidationSchema
                  }
                  onSubmit={(values, actions) => {
                    const {
                      setSubmitting,
                      validateForm,
                      setTouched,
                      resetForm,
                    } = actions;

                    handleStepSubmit(values, {
                      setSubmitting,
                      validateForm,
                      setTouched,
                      resetForm,
                    });
                  }}
                  validateOnChange={true}
                  validateOnBlur={true}
                >
                  {({
                    values,
                    isValid,
                    validateForm,
                    setTouched,
                    isSubmitting,
                    setSubmitting,
                    setFieldValue,
                    errors,
                    touched,
                  }) => {
                    //console.log(values);
                    if (
                      values.monthly_revenue === "One"
                      // !document
                      //   .querySelector(".low-rev-info")
                      //   ?.classList.contains("visible")
                    ) {
                      document
                        .querySelector(".low-rev-info")
                        ?.classList.add("visible");

                      document
                        .querySelector("span.critical-revenue")
                        ?.classList.add("visible");
                    } else {
                      document
                        .querySelector(".low-rev-info")
                        ?.classList.remove("visible");

                      document
                        .querySelector("span.critical-revenue")
                        ?.classList.remove("visible");
                    }
                    return (
                      <Form>
                        {showHoldModal && (
                          <HoldModal setOpen={setShowHoldModal} />
                        )}
                        {currentStep === 1 && (
                          <div>
                            <div className="mb-6">
                              <label className="font-medium text-[13px] text-[#101828] ">
                                {localizationModule.getText("fullname")}
                              </label>
                              <div className="mt-[10px]">
                                <Field
                                  type="text"
                                  name="full_name"
                                  className="bg-white border border-[#30303033] w-full px-3 py-[10px] rounded-lg"
                                  placeholder="John Doe"
                                />
                                <ErrorMessage
                                  name="full_name"
                                  component="div"
                                  className="text-red-600"
                                />
                              </div>
                            </div>
                            <div className="mb-6">
                              <label className="font-medium text-[13px] text-[#101828] ">
                                {localizationModule.getText("businessname")}
                              </label>
                              <div className="mt-[10px]">
                                <Field
                                  type="text"
                                  name="business_name"
                                  className="bg-white border border-[#30303033] w-full px-3 py-[10px] rounded-lg"
                                  placeholder="John's Coffee Shop"
                                />
                                <ErrorMessage
                                  name="business_name"
                                  component="div"
                                  className="text-red-600"
                                />
                              </div>
                            </div>

                            <div className="mb-6">
                              <label className="font-medium text-[13px] text-[#101828] ">
                                {localizationModule.getText("emailaddress")}
                              </label>
                              <div className="mt-[10px]">
                                <div className="bg-white flex gap-x-2 border border-[#30303033] w-full px-3 py-[10px] rounded-lg">
                                  <img src={mailIcon} alt="" />
                                  <Field
                                    type="email"
                                    name="email"
                                    className="w-full"
                                    placeholder="john@example.com"
                                  />
                                </div>
                                <ErrorMessage
                                  name="email"
                                  component="div"
                                  className="text-red-600"
                                />
                              </div>
                            </div>
                            <div className="mb-8">
                              <label className="font-medium text-[13px] text-[#101828] ">
                                {localizationModule.getText("phone")}
                              </label>
                              <div className="mt-[10px]">
                                <PhoneInput
                                  country={"us"}
                                  inputProps={{ name: "phone" }}
                                  value={values.phone}
                                  inputClass="phone-input"
                                  isValid={!Boolean(errors.phone)}
                                  // className="bg-white border border-[#30303033] w-full px-3 py-[10px] rounded-xl"
                                  onChange={(value, countryData) => {
                                    setCountry(
                                      countryData.countryCode?.toUpperCase()
                                    );
                                    setFieldValue("phone", value);
                                  }}
                                  countryCodeEditable={false}
                                />
                                {/* <div className="">
                                  <ErrorMessage
                                    name="phone"
                                    component="div"
                                    className="text-red-600"
                                  />
                                </div> */}
                                {errors.phone && (
                                  <span className=" text-red-600">
                                    {errors.phone}
                                  </span>
                                )}
                                {/* <div className="bg-white flex gap-x-2 border border-[#30303033] w-full px-3 py-[10px] rounded-lg">
                                  <img src={phonIcon} alt="" />
                                  <Field
                                    type="number"
                                    name="phone"
                                    className="  [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none w-full"
                                    placeholder="(123) 456-7890"
                                  />
                                </div>
                                <ErrorMessage
                                  name="phone"
                                  component="div"
                                  className="text-red-600"
                                /> */}
                              </div>
                            </div>
                          </div>
                        )}
                        {/* step-2 */}
                        {currentStep === 2 && (
                          <div>
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-6 mb-6">
                              <div>
                                <label className="font-medium text-[13px] text-[#101828] ">
                                  {localizationModule.getText("businesstype")}
                                </label>
                                <div className="mt-[10px]">
                                  <Field
                                    name="business_type"
                                    as="select"
                                    className="bg-white border border-[#30303033] w-full px-3 py-[10px] rounded-lg"
                                  >
                                    <option value="" selected>
                                      ---
                                    </option>
                                    {busisnesstypes.industries.map(
                                      (industry) => (
                                        <option
                                          value={industry}
                                          key={`type-option-${industry}`}
                                        >
                                          {industry}
                                        </option>
                                      )
                                    )}
                                  </Field>
                                  <div className="mt-[10px]">
                                    <ErrorMessage
                                      name="business_type"
                                      component="div"
                                      className="text-red-600"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div>
                                <label className="font-medium text-[13px] text-[#101828] ">
                                  {localizationModule.getText(
                                    "Business Establishment Date"
                                  )}
                                </label>
                                <div className="mt-[10px]">
                                  <Field
                                    type="date"
                                    name="business_date"
                                    format="MM-DD-YYYY"
                                    max={`${new Date().getFullYear()}-12-31`}
                                    onClick={(e) =>
                                      e.target?.showPicker &&
                                      e.target?.showPicker()
                                    }
                                    // as="select"
                                    className="bg-white border border-[#30303033] w-full px-3 py-[10px] rounded-lg"
                                  />
                                  <div className="mt-[10px]">
                                    <ErrorMessage
                                      name="business_date"
                                      component="div"
                                      className="text-red-600"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-6 mb-2">
                              <div>
                                <label className="font-medium text-[13px] text-[#101828] ">
                                  {localizationModule.getText("Business State")}
                                </label>
                                <Field
                                  name="business_state"
                                  as="select"
                                  className="bg-white border border-[#30303033] w-full px-3 py-[10px] rounded-lg mt-[10px]"
                                >
                                  <option value="" selected>
                                    ---
                                  </option>
                                  {Object.values(states).map((state) => (
                                    <option
                                      value={state}
                                      key={`state-option-${state}`}
                                    >
                                      {state}
                                    </option>
                                  ))}
                                  {/* <option value="Retail">Retail</option>
                              <option value="Green">Green</option>
                              <option value="Blue">Blue</option> */}
                                </Field>
                                <div className="mt-[10px]">
                                  <ErrorMessage
                                    name="business_state"
                                    component="div"
                                    className="text-red-600"
                                  />
                                </div>
                              </div>
                              <div className="mb-6">
                                <label className="font-medium text-[13px] text-[#101828] ">
                                  {localizationModule.getText(
                                    "Credit score range"
                                  )}
                                </label>
                                <div className="mt-[10px]">
                                  <Field
                                    name="avg_monthly_credit"
                                    as="select"
                                    className="bg-white border border-[#30303033] w-full px-3 py-[10px] rounded-lg"
                                  >
                                    <option value="" selected>
                                      ---
                                    </option>
                                    <option value="500">
                                      {" "}
                                      {localizationModule.getText("below")} 500
                                    </option>
                                    <option value="599">500 - 599</option>
                                    <option value="649">600 - 649</option>
                                    <option value="699">650 - 699</option>
                                    <option value="700">700+</option>
                                  </Field>
                                  <div className="mt-[10px]">
                                    <ErrorMessage
                                      name="avg_monthly_credit"
                                      component="div"
                                      className="text-red-600"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="mb-6"
                              style={{ position: "relative" }}
                            >
                              <div className="low-rev-info">
                                <div
                                  onClick={() => {
                                    document
                                      .querySelector(".low-rev-info")
                                      ?.classList.remove("visible");
                                    document
                                      .querySelector("span.critical-revenue")
                                      ?.classList.remove("visible");
                                  }}
                                  className="close"
                                >
                                  🗙
                                </div>
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      localizationModule.getText(
                                        "lowRevenueInfo"
                                      ),
                                  }}
                                ></span>
                              </div>
                              <label className="font-medium text-[13px] text-[#101828] ">
                                {localizationModule.getText("Monthly Revenue")}
                              </label>
                              <div
                                role="group"
                                aria-labelledby="my-radio-group"
                                className="mt-[10px] flex flex-col justify-center gap-y-[10px]"
                              >
                                <label
                                  className={`flex gap-x-3 items-center font-medium text-[13px] leading-[20px] ${
                                    values.monthly_revenue === "One"
                                      ? "text-[#101828]"
                                      : "text-[#303030A3]"
                                  }`}
                                >
                                  <Field
                                    type="radio"
                                    name="monthly_revenue"
                                    value="One"
                                    className="radiobtn"
                                  />
                                  <p>
                                    {" "}
                                    <span className="critical-revenue">
                                      $0K
                                    </span>{" "}
                                    - $20K
                                  </p>
                                </label>
                                <label
                                  className={`flex gap-x-3 items-center font-medium text-[13px] leading-[20px] ${
                                    values.monthly_revenue === "Two"
                                      ? "text-[#101828]"
                                      : "text-[#303030A3]"
                                  }`}
                                >
                                  <Field
                                    type="radio"
                                    name="monthly_revenue"
                                    value="Two"
                                    className="radiobtn"
                                  />
                                  $20K - $50K
                                </label>
                                <label
                                  className={`flex gap-x-3 items-center font-medium text-[13px] leading-[20px] ${
                                    values.monthly_revenue === "Three"
                                      ? "text-[#101828]"
                                      : "text-[#303030A3]"
                                  }`}
                                >
                                  <Field
                                    type="radio"
                                    name="monthly_revenue"
                                    value="Three"
                                    className="radiobtn"
                                  />
                                  $50K - $250K
                                </label>
                                <label
                                  className={`flex gap-x-3 items-center font-medium text-[13px] leading-[20px] ${
                                    values.monthly_revenue === "four"
                                      ? "text-[#101828]"
                                      : "text-[#303030A3]"
                                  }`}
                                >
                                  <Field
                                    type="radio"
                                    name="monthly_revenue"
                                    value="four"
                                    className="radiobtn"
                                  />
                                  {localizationModule.getText("above")} $250K -
                                  $1M
                                </label>
                              </div>
                            </div>

                            <div className="mb-6">
                              <label className="font-medium text-[13px] text-[#101828] ">
                                {localizationModule.getText(
                                  "Requested Ammount"
                                )}
                              </label>
                              <div className="mt-[10px]">
                                <Field name="current_funding">
                                  {({ field, form }) => (
                                    <input
                                      placeholder="$20,000"
                                      type="text"
                                      className="bg-white flex  border border-[#30303033] w-full px-3 py-[10px] rounded-lg"
                                      {...field}
                                      value={`$${field.value}`}
                                      onChange={(e) => {
                                        const rawValue = e.target.value.replace(
                                          /[^0-9.-]+/g,
                                          ""
                                        );
                                        form.setFieldValue(
                                          field.name,
                                          formatNumber(Number(rawValue))
                                        );
                                      }}
                                    />
                                  )}
                                </Field>

                                <ErrorMessage
                                  name="current_funding"
                                  component="div"
                                  className="text-red-600"
                                />
                              </div>
                            </div>
                            {/* <div className="mb-6">
                              <label className="font-medium text-[13px] text-[#101828] ">
                                {localizationModule.getText(
                                  "Consent to Credit Check"
                                )}
                              </label>
                              <div
                                role="group"
                                aria-labelledby="checkbox-group"
                                className="mt-[10px]"
                              >
                                <label className="flex gap-x-3 items-start text-[#303030A3] font-medium text-[13px] leading-[20px] ">
                                  <Field
                                    type="checkbox"
                                    name="consent_credit_check"
                                    className="mt-1"
                                  />
                                  {localizationModule.getText("iauthorize")}
                                </label>
                                <ErrorMessage
                                  name="consent_credit_check"
                                  component="div"
                                  className="text-red-600"
                                />
                              </div>
                            </div>
                            <div className="mb-8">
                              <label
                                htmlFor="terms_conditions"
                                className="font-medium text-[13px] text-[#101828] "
                              >
                                {localizationModule.getText(
                                  "Agreement to Terms & Conditions"
                                )}
                              </label>
                              <div
                                role="group"
                                aria-labelledby="checkbox-group"
                                className="mt-[10px]"
                              >
                                <label className="flex gap-x-3 items-start text-[#303030A3] font-medium text-[13px] leading-[20px] ">
                                  <Field
                                    type="checkbox"
                                    name="terms_conditions"
                                    className="mt-1"
                                  />

                                  {localizationModule.getText("iauthorize")}
                                </label>
                                <ErrorMessage
                                  name="terms_conditions"
                                  component="div"
                                  className="text-red-600"
                                />
                              </div>
                            </div> */}
                          </div>
                        )}

                        {/* step-3 */}
                        {currentStep === 3 && (
                          <div>
                            {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-6 mb-6">
                            <div>
                              <label className="font-medium text-[13px] text-[#101828] ">
                                {localizationModule.getText("AverageMonthly")}
                              </label>
                              <div className="mt-[10px]">
                                <Field
                                  type="text"
                                  name="avg_monthly_sales_1"
                                  className="bg-white border border-[#30303033] w-full px-3 py-[10px] rounded-lg"
                                  placeholder="$15,000"
                                />
                                <ErrorMessage
                                  name="avg_monthly_sales_1"
                                  component="div"
                                  className="text-red-600"
                                />
                              </div>
                            </div>
                            <div>
                              <label className="font-medium text-[13px] text-[#101828] ">
                                {localizationModule.getText(
                                  "AverageMonthlyDebit"
                                )}
                              </label>
                              <div className="mt-[10px]">
                                <Field
                                  type="text"
                                  name="avg_monthly_sales_2"
                                  className="bg-white border border-[#30303033] w-full px-3 py-[10px] rounded-lg"
                                  placeholder="$5,000"
                                />
                                <ErrorMessage
                                  name="avg_monthly_sales_2"
                                  component="div"
                                  className="text-red-600"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="mb-6">
                            <label className="font-medium text-[13px] text-[#101828] ">
                              {localizationModule.getText(
                                "OtherMonthlyRevenue"
                              )}

                              <span className="font-normal text-[#30303066]">
                                ({localizationModule.getText("optional")})
                              </span>
                            </label>
                            <div className="mt-[10px]">
                              <Field
                                type="text"
                                name="other_monthly_sources"
                                className="bg-white border border-[#30303033] w-full px-3 py-[10px] rounded-lg"
                                placeholder="Please describe any additional revenue streams"
                              />
                              <ErrorMessage
                                name="other_monthly_sources"
                                component="div"
                                className="text-red-600"
                              />
                            </div>
                          </div>
                          <div className="mb-6">
                            <label className="font-medium text-[13px] text-[#101828] ">
                              {localizationModule.getText("anyexistingloans")}
                            </label>
                            <div
                              role="group"
                              aria-labelledby="my-radio-group"
                              className="mt-[10px] flex flex-col justify-center gap-y-[10px]"
                            >
                              <label
                                className={`flex gap-x-3 items-center font-medium text-[13px] leading-[20px] ${
                                  values.existing_loans === "yes"
                                    ? "text-[#101828]"
                                    : "text-[#303030A3]"
                                }`}
                              >
                                <Field
                                  type="radio"
                                  name="existing_loans"
                                  value="yes"
                                  className="radiobtn"
                                />
                                {localizationModule.getText("yes")}
                              </label>
                              <label
                                className={`flex gap-x-3 items-center font-medium text-[13px] leading-[20px] ${
                                  values.existing_loans === "no"
                                    ? "text-[#101828]"
                                    : "text-[#303030A3]"
                                }`}
                              >
                                <Field
                                  type="radio"
                                  name="existing_loans"
                                  value="no"
                                  className="radiobtn"
                                />
                                {localizationModule.getText("no")}
                              </label>
                            </div>
                          </div>
                          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-6 mb-6">
                            <div>
                              <label className="font-medium text-[13px] text-[#101828] ">
                                {localizationModule.getText(
                                  "TotalExistingAmount"
                                )}
                              </label>
                              <div className="mt-[10px]">
                                <Field
                                  type="text"
                                  name="existing_financing_amount"
                                  className="bg-white border border-[#30303033] w-full px-3 py-[10px] rounded-lg"
                                  placeholder="$25,000"
                                />
                                <ErrorMessage
                                  name="existing_financing_amount"
                                  component="div"
                                  className="text-red-600"
                                />
                              </div>
                            </div>
                            <div>
                              <label className="font-medium text-[13px] text-[#101828] ">
                                {localizationModule.getText(
                                  "MonthlyPaymentAmount"
                                )}
                              </label>
                              <div className="mt-[10px]">
                                <Field
                                  type="text"
                                  name="monthly_payment"
                                  className="bg-white border border-[#30303033] w-full px-3 py-[10px] rounded-lg"
                                  placeholder="$500"
                                />
                                <ErrorMessage
                                  name="monthly_payment"
                                  component="div"
                                  className="text-red-600"
                                />
                              </div>
                            </div>
                          </div> */}
                            {/* <div className="mb-6">
                            <label className="font-medium text-[13px] text-[#101828] ">
                              {localizationModule.getText("BankInformation")}
                              <span className="font-normal text-[#30303066]">
                                ({localizationModule.getText("optional")})
                              </span>
                            </label>
                            <div className="mt-[10px]">
                              <Field
                                type="text"
                                name="bank_acc_inf"
                                className="bg-white border border-[#30303033] w-full px-3 py-[10px] rounded-lg"
                                placeholder="Indicate the bank where your business account is held"
                              />
                              <ErrorMessage
                                name="bank_acc_inf"
                                component="div"
                                className="text-red-600"
                              />
                            </div>
                          </div> */}
                            <div style={{ marginBottom: "20px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection:
                                    window.innerWidth < 800 ? "column" : "row",
                                  alignItems: "center",
                                  marginBottom: 10,
                                }}
                              >
                                <img src={secured} alt="secured" />
                                <p
                                  style={{
                                    fontSize: 14,
                                    paddingLeft: 10,
                                    color: "rgba(48, 48, 48, 0.64)",
                                  }}
                                >
                                  {localizationModule.getText("protected")}
                                </p>
                              </div>
                              <label
                                htmlFor="business_address"
                                className="font-medium text-[13px] text-[#101828] "
                              >
                                {localizationModule.getText("UploadDocuments")}
                              </label>
                              {Array.from({ length: 1 }).map((_, index) => {
                                return (
                                  <div
                                    key={`input-${index}`}
                                    className="mt-[10px]  border-dotted border-[#EFEFEF] border-2"
                                  >
                                    <input
                                      type="file"
                                      id={`average_monthly_card${index}`}
                                      name={`statment${index}`}
                                      className="hidden"
                                      ref={(node) => {
                                        inputRefs[index] = node;
                                      }}
                                      onChange={(event) => {
                                        const file =
                                          event.currentTarget.files[0];
                                        if (FILE_SIZE < file?.size) {
                                          return void alert(
                                            "File size exceeds 5mb limit"
                                          );
                                        }
                                        if (
                                          !SUPPORTED_FORMATS.includes(
                                            file?.type
                                          )
                                        ) {
                                          console.log(file?.type);
                                          return void alert(
                                            "Unsupported file format"
                                          );
                                        }
                                        setFieldValue("statment", [
                                          ...values.statment.slice(0, index),
                                          file,
                                          ...values.statment.slice(index + 1),
                                        ]);
                                      }}
                                    />
                                    <div className="flex flex-col items-center py-6 max-w-md mx-auto ">
                                      {!values.statment[index] && (
                                        <div>
                                          <img
                                            src={upload_Icon}
                                            alt="upload"
                                            className="w-full h-full"
                                          />
                                        </div>
                                      )}
                                      {values.statment[index] && (
                                        <div>
                                          <embed
                                            alt="Preview"
                                            style={{
                                              width: "300px",
                                              height: "145px",
                                              objectFit: "cover",
                                            }}
                                            src={URL.createObjectURL(
                                              values.statment[index]
                                            )}
                                          />
                                          {/* <img
                                        src={URL.createObjectURL(
                                          values.average_monthly_card
                                        )}
                                        alt="Preview"
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                          objectFit: "cover",
                                        }}
                                      /> */}
                                        </div>
                                      )}
                                      <h4 className="font-medium text-[13px] text-center text-[#101828] mt-3 mb-1">
                                        {localizationModule.getText(
                                          "Chooseafile"
                                        )}
                                      </h4>
                                      <p className="mb-0 text-center  font-medium text-[13px] text-[#303030A3]">
                                        {localizationModule.getText(
                                          "allowedfiletype"
                                        )}
                                      </p>
                                      <div className="mt-4">
                                        <button
                                          type="button"
                                          className="border rounded-full border-[#30303033] py-[14px] px-6  font-medium text-[13px] text-[#171717] hover:bg-[#5D74F1] hover:text-[#fff] "
                                          onClick={() => handleImage(index)}
                                        >
                                          {localizationModule.getText(
                                            "Browse File"
                                          )}
                                        </button>
                                      </div>
                                    </div>
                                    {errors.statment?.[index] &&
                                    touched.statment?.[index] ? (
                                      <div style={{ color: "red" }}>
                                        {errors.statment?.[index]}
                                      </div>
                                    ) : null}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}

                        {/* buttoms */}
                        {/* {currentStep > 1 && (
                          <button
                            type="button"
                            onClick={handlePrevious}
                            className=" border rounded-full border-[#30303033] py-[14px] px-6  font-medium text-sm w-full text-[#171717] mb-4 hover:bg-[#5D74F1] hover:text-[#fff] whitespace-nowrap block sm:hidden md:hidden lg:hidden xl:hidden"
                          >
                            {localizationModule.getText("Previous Step")}
                          </button>
                        )} */}
                        <div className="flex justify-between items-center">
                          <div className=" flex gap-3 w-full sm:w-auto md:w-auto lg:w-auto xl:w-auto">
                            {/* {currentStep > 1 && (
                            <button
                              type="button"
                              onClick={handlePrevious}
                              className=" border rounded-full border-[#30303033] py-[14px] px-6  font-medium text-sm text-[#171717] hover:bg-[#5D74F1] hover:text-[#fff] whitespace-nowrap hidden sm:block md:block lg:block xl:block"
                            >
                              {localizationModule.getText("Previous Step")}
                            </button>
                          )} */}

                            {currentStep === 3 ? (
                              <button
                                disabled={isSubmitting}
                                type="submit"
                                style={{ width: 120 }}
                                className="text-white font-medium text-sm bg-[#5D74F1] py-[14px] px-[26px] rounded-[100px] w-full hover:bg-blue-400 hover:text-[#000]"
                              >
                                {isSubmitting ? (
                                  <span className="loader"></span>
                                ) : (
                                  localizationModule.getText("Submit")
                                )}
                              </button>
                            ) : (
                              currentStep < 3 && (
                                <button
                                  type="submit"
                                  style={{ width: 160 }}
                                  disabled={isSubmitting}
                                  className="text-white font-medium text-sm bg-[#5D74F1] py-[14px] px-[26px] rounded-[100px] w-full hover:bg-blue-400 hover:text-[#000] whitespace"
                                >
                                  {isSubmitting ? (
                                    <span className="loader"></span>
                                  ) : (
                                    localizationModule.getText("nextstep")
                                  )}
                                </button>
                              )
                            )}
                          </div>
                          <div className="ml-[15px] sm:ml-0 md:ml-0 lg:ml-0 xl:ml-0">
                            {/* <button
                        type="button"
                        className="border rounded-full border-[#30303033] py-[14px] px-6  font-medium text-sm text-[#171717] hover:bg-[#5D74F1] hover:text-[#fff] "
                      >
                        {localizationModule.getText('save')}
                      </button> */}
                          </div>
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              </div>
            </div>
          </div>
          <div className="bg-white col-span-12 sm:col-span-12 md:col-span-5 lg:col-span-5 xl:col-span-5 rounded-2xl border border-[#fff] p-6 h-full block mt-3 sm:block md:hidden lg:hidden xl:hidden">
            <div>
              <h4 className="text-[#171717] font-semibold text-base">
                {localizationModule.getText("needhelp")}
              </h4>
              <p className="font-normal text-base text-[#303030A3] mt-[10px]">
                {localizationModule.getText("gettoknowreach")}
              </p>
              <button
                className="border rounded-full border-[#30303033] shadow-[0px -0.5px 0px 0px #16191D1F inset] px-3 py-[10px] font-medium text-sm text-[#171717] hover:bg-[#5D74F1] hover:text-[#fff] mt-[30px]"
                onClick={() =>
                  window.open("mailto:support@procash.ai", "_self")
                }
              >
                {localizationModule.getText("contactus")}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* {isModalOpen && <SuccessModal onClose={closeModal} />} */}
    </>
  );
};

export default StepForm;
